import { Component, Input } from '@angular/core';


/**
 * LineButtonComponent
 * ラインログインなどに使用されるボタン
 * text属性を設定することでボタンの文字列を変更できる
 * HTMLに設置する場合は
 * 	<line-button text="hoge"></line-button>
 * で設置できる。
 */
@Component({
	selector: 'line-button',
	templateUrl: './LineButtonComponent.html',
	styleUrls: ['./LineButtonComponent.scss'],
})
export class LineButtonComponent {

	// ボタンテキスト
	@Input() text: string;
	// 接続URL
	@Input() loginUrl: string;

	// ラインボタンのベースタイプアセットPath
	public lineBtn = 'assets/LineLoginButtonImage/images/DeskTop/2x/44dp/line_88.png';

	/**
	 * constructor
	 */
	constructor() {


	}

}
